/**
 * Inline style for admin tables with fixed column widths + horizontal overflow.
 *
 * Building block — prefer {@link getAdminTableProps}, which pairs this with the
 * sticky-header styles and the cell containment that fixed layout requires.
 * Applying this alone gives a table whose cells bleed into their neighbours.
 *
 * Wide tables use `minWidth` so columns can grow past the viewport; horizontal
 * pan is **page-level** (not an `overflow-x` ancestor around the table). Wrapping
 * sticky tables in `Table.ScrollContainer` or `overflow-x: auto` creates a
 * scrollport that breaks viewport `stickyHeaderOffset` — column headers float
 * mid-table with body rows above them. {@link AdminStickyListLayout} pins the
 * filter band with sticky `left: 0`; {@link AdminAppShell} clips the shell header
 * so the avatar stays on-screen.
 */

import type { CSSProperties } from 'react';
import { rem } from '@mantine/core';

/**
 * Returns `tableLayout: fixed` styles with a minimum width so columns can grow
 * past the viewport; page-level horizontal scroll pans the table while sticky
 * filters / AppShell header stay pinned.
 */
export function getAdminResizableTableStyle(minWidthPx: number): CSSProperties {
  return {
    tableLayout: 'fixed',
    width: '100%',
    minWidth: rem(minWidthPx),
  };
}
